import { Observable } from 'rxjs';
import { TrialEnvironmentalLocation } from '../model/trial-environmental-location.model';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../../../environment.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { StudyReference } from '../model/study-reference.model';
import { ColumnModel } from '../model/column.model';

@Injectable()
export class QueryService {
    private baseUrl = SERVER_API_URL;

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    public getTraitLocations(traits: number[], environmentIds: number[]): Observable<TrialEnvironmentalLocation[]> {
        return this.http.get<TrialEnvironmentalLocation[]>(this.baseUrl +
            `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/locations?traits=` + traits
            + '&environmentIds=' + environmentIds);
    }

    public getTraitStudies(traits: number[], environmentIds: number[]): Observable<StudyReference[]> {
        return this.http.get<StudyReference[]>(this.baseUrl +
            `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/studies?traits=` + traits
            + '&environmentIds=' + environmentIds);
    }

    public getEnvironmentColumns(traits: number[], environmentIds: number[]): Observable<HttpResponse<ColumnModel[]>> {
        return this.http.get<ColumnModel[]>(this.baseUrl +
            `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/environment/columns?traits=` + traits
            + '&environmentIds=' + environmentIds,
        { observe: 'response' });
    }
}